import React from 'react';
import {Item, Section} from '../components/types';
import {useVeiledere} from '../context/VeilederContext';

const extractVeiledereSections = (data: any) => {
  const sections: Section[] = [];

  if (data && data.veiledere) {
    if (data.veiledere.links) {
      sections.push({
        title: 'Veiledere',
        data: data.veiledere.links,
      });
    }

    Object.keys(data.veiledere).forEach(key => {
      if (key !== 'links' && data.veiledere[key]?.links) {
        sections.push({
          title: data.veiledere[key].name,
          data: data.veiledere[key].links,
        });
      }
    });
  }

  return sections;
};

export const VeiledereScreen = () => {
  const veiledere = useVeiledere();

  const sections = veiledere ? extractVeiledereSections(veiledere) : [];

  return (
    <div className="screenContainer">
      {sections.length > 0 ? (
        sections.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            <h2 className="sectionHeader sectionHeaderVeiledere">
              {section.title}
            </h2>
            <ul>
              {section.data.map((item: Item, itemIndex: number) => (
                <li key={item.url + itemIndex}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkButton">
                    <span className="linkText">{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))
      ) : (
        <p>Henter ny informasjon...</p>
      )}
    </div>
  );
};

export default VeiledereScreen;
